import { render } from "./SellerCustomerShow.vue?vue&type=template&id=0211eecc"
import script from "./SellerCustomerShow.vue?vue&type=script&lang=js"
export * from "./SellerCustomerShow.vue?vue&type=script&lang=js"
script.render = render

export default script